export default "__VITE_ASSET__BecRtN8E__"